import OutboundIntegrations from './OutboundIntegrations';
export default OutboundIntegrations;
